var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133,
    height: 250,
    viewBox: "0 0 133 250",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5085 91.1713C108.87 37.9853 186.016 40.5851 195.971 15.5967C234.531 -34.38 310.552 49.6684 310.552 100.313C310.552 150.132 279.951 166.544 189.058 215.294L188.19 215.759C161.697 229.968 96.3755 272.745 53.1029 234.348C9.83039 195.951 -31.9938 142.972 37.5085 91.1713Z",
    fill: "#FE9342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector8);
export default __webpack_public_path__ + "static/media/vector8.da4aa1fac43e16cf445d8e40364efc89.svg";
export { ForwardRef as ReactComponent };